import { createContext, useContext } from 'react';

import { JabraSitecoreTheme } from 'api/themeQueries';

export const JabraThemesListContext = createContext<JabraSitecoreTheme[]>([]);

export const useJabraThemesList = () => {
  return useContext(JabraThemesListContext);
};
